import { RadioButton } from "primereact/radiobutton";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useAppSelector, useAppDispatch } from "../../redux/hooks";
import { selectedPayment } from "../../redux/slices/payments";
import '../../assests/css/common/responsive-ui.css'

const InvoicePayment = (props: any) => {
  const { t } = useTranslation();
  const dispatch = useAppDispatch();
  const selectedPaymentMode = useAppSelector((state) => state.payments);
  const [selectedPaymentId, setSelectedPaymentId] = useState<number>(5);

  let paymentmodesdata = [
    {
      id: "11",
      mode: "Cash At Store",
      code: "CASH",
      modeImage: process.env.PUBLIC_URL + "/assests/images/cash.jpg",
      isSelected: false,
    },
    {
      id: "1",
      mode: t("payment_mode1"),
      code: "COD",
      modeImage: process.env.PUBLIC_URL + "/assests/images/cod.jpg",
      isSelected: true,
    },
    
    {
      id: "7",
      mode: "Online Payment",
      code: "OPTONL",
      modeImage: process.env.PUBLIC_URL + "/assests/images/credit-card.png",
      isSelected: false,
    },
    // {
    //   id: "8",
    //   mode: "Credit",
    //   code: "OPTONL",
    //   modeImage: process.env.PUBLIC_URL + "/assests/images/credit-card.png",
    //   isSelected: false,
    // },
    {
      id: "6",
      mode: "Payment Link",
      code: "",
      modeImage: process.env.PUBLIC_URL + "/assests/images/Betaallink.png",
      isSelected: true,
    },
    // {
    //   id: "5",
    //   mode: "UPI ",
    //   code: "OPTUPI",
    //   modeImage: process.env.PUBLIC_URL + "/assests/images/oup.jpg",
    //   isSelected: false,
    // }
  ];

  if (props.displayOthersPayment) {
    paymentmodesdata.push({
      id: "2",
      mode: "Others ",
      code: "Others",
      modeImage: "",
      isSelected: false,
    });
  }

  useEffect(() => {
    if (selectedPaymentMode.selectedPayment === null) {
      setSelectedPaymentId(5);
    }
  });

  useEffect(() => {
    props.updatePaymentId(selectedPaymentId);
  }, [selectedPaymentId]);

  const savePaymentMode = (e: any, value: any) => {
    setSelectedPaymentId(value.id);
    if (props.displayOthersPayment) {
      value?.id === "2" ? props.setOtherPaymentData(true) : props.setOtherPaymentData(false)
    }
    dispatch(selectedPayment(value));
  };

  return (
    <>
      <div className="flex flex-wrap align-items-center">
        {paymentmodesdata.map((category) => {
          return (
            <div key={category.id} className="mr-4 mb-2 responsive-pay flex align-items-center">
              <RadioButton
                inputId={category.id}
                name="category"
                value={category}
                onChange={(e) => savePaymentMode(e, e.value)}
                checked={selectedPaymentId.toString() === category.id}
              />
              <label htmlFor={category.id} className="ml-2 font-medium cursor-pointer">
                {category.mode}
              </label>
              <div className="ml-2 payment-mode-image flex align-items-center">
                <img
                  src={category.modeImage}
                  alt={category.mode}
                  style={{ height: '32px', width: 'auto', maxWidth: '100px', objectFit: 'contain' }}
                  onError={(e: any) => { e.target.style.display = 'none'; }}
                />
              </div>
            </div>
          );
        })}
      </div>
    </>
  )
}

export default InvoicePayment;